import React from "react";
import { compose } from "redux";
import classNames from "classnames";

import withTranslations from "../../../../../hocs/withTranslations";
import { PLAN_PERMISSIONS_SECTIONS } from "../../../../../redux/modules/auth/userPermissions/selector";
import { constants as priceAlertsConstants } from "../../../../../redux/modules/priceAlerts";
import ContentSection from "../../../common/ContentSection";
import PageTitle from "../../../common/PageTitle";
import RequirePlanPermission from "../../../common/RequirePlanPermission";
import UniversalTableLiteWeb from "../../../common/UniversalTableLiteWeb";
import useIsDesktop from "../../../landingPage/hooks/useIsDesktop";
import LandingTypography from "../../../landingPage/pages/Homepage/components/LandingTypography";
import NoPriceAlerts from "../components/NoPriceAlerts";

const PriceAlertsTable = ({ translate }) => {
  const isDesktop = useIsDesktop();

  return (
    <RequirePlanPermission permissions={PLAN_PERMISSIONS_SECTIONS.PRICE_ALERTS}>
      <LandingTypography>
        <ContentSection>
          <PageTitle title={translate("price-alerts-page_title")} />
          <h1
            className={
              "normal-case text-2xl text-black line-height-130 font-bold mb-4"
            }
          >
            {translate("price-alerts-page_header")}
          </h1>
          <p
            className={classNames("text-black line-height-150", {
              "text-sm  mb-4": isDesktop,
              "text-base  mb-6": !isDesktop
            })}
          >
            {translate("price-alerts-page_description")}
          </p>
          <UniversalTableLiteWeb
            resourceId={1}
            fetchConfigParams={{
              urlPath: "app.priceAlerts.tableConfig"
            }}
            fetchDataParams={{
              urlPath: "app.priceAlerts.tableWithOptions"
            }}
            useUrlSettings
            refreshOn={[priceAlertsConstants.FETCH_PRICE_ALERTS_SUCCESS]}
            emptyState={
              <NoPriceAlerts
                title={translate("no_price_alerts_title")}
                description={translate("no_price_alerts_description")}
                showButton
                buttonLabel={translate("no_price_alerts_go_to_stocks")}
              />
            }
            emptyStateWithFilters={
              <NoPriceAlerts
                title={translate("no_price_alerts_filtered_title")}
                description={translate("no_price_alerts_filtered_description")}
              />
            }
          />
        </ContentSection>
      </LandingTypography>
    </RequirePlanPermission>
  );
};

export default withTranslations(PriceAlertsTable);
